import { render, staticRenderFns } from "./EcommerceJobBoardReports.vue?vue&type=template&id=2d8e7ef0&"
import script from "./EcommerceJobBoardReports.vue?vue&type=script&lang=js&"
export * from "./EcommerceJobBoardReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports